module.exports = __webpack_public_path__ + "img/Efficiency Icon - charcoal.84ccd2e7.svg";